<template>
  <tr>
    <td title="Klant">
      <BadgeComponent v-if="hasCustomer" :customer="damage.customer.data"/>
    </td>
    <td title="Adres">
      <!--  @if(isset($damage->customer) && !$damage->customer->isChild())-->
      <!-- TODO incl.  && !customerIsChild -->
      <span v-if="hasCustomer && getProperty !== null">
        {{ getProperty.street }} {{ getProperty.number }}{{ getProperty.number_addition }}<br>
        {{ getProperty.postal_code }} {{ getProperty.city }}
      </span>
      <span v-else>
        -
      </span>
    </td>
    <td title="Contactgegevens">
      <template v-if="hasCustomer">
        <span v-if="getEmail">
          <i class="mdi mdi-at" title="E-mail"></i>
          {{ getEmail }}
          <br>
        </span>
        <span v-if="getPhone">
          <i class="mdi mdi-phone" title="Telefoon"></i>
          <a :href="'tel:' + getPhone">{{ getPhone }}</a>
          <br>
        </span>
        <span v-if="getMobile">
          <i class="mdi mdi-cellphone" title="Mobiel"></i>
          <a :href="'tel:' + getMobile">{{ getMobile }}</a>
        </span>
      </template>
    </td>
    <td title="Schadenr">
      <a v-if="getDamageLink.length > 0" :href="getDamageLink">
        {{ damage.damage_number }}
      </a>
      <span v-else>
        {{ damage.damage_number }}
      </span>
    </td>
    <td title="Schadedatum">
      {{ dateForHumans(damage.date) }}
    </td>
    <td title="Oorzaak">
      <span class="hidden-lg">{{ shorten(damage.cause, 60) }}</span>
      <span class="visible-lg">{{ shorten(damage.cause, 100) }}</span>
    </td>
    <td title="Maatschappij">
      {{ getAgencyName }}
    </td>
    <td title="Schadenr.Mij">
      {{ damage.external_number }}
    </td>
  </tr>
</template>

<script>
import BadgeComponent from "~/modules/customer/components/BadgeComponent";
import moment from 'moment';
import 'moment/locale/nl';
import DateFormatEnum from "~/enums/DateFormatEnum";

export default {
  name: "SelectionDamageRowComponent",
  props: {
    damage: {
      type: Object,
      required: true
    }
  },
  components: {
    BadgeComponent,
  },
  data() {
    return {}
  },
  methods: {
    moment,
    dateForHumans(date) {
      return moment(date).format(DateFormatEnum.DISPLAY_DATE);
    },
    shorten(string, maxLength, separator = ' ') {
      if (string === null || typeof string === 'undefined' || string.length === 0) {
        string = '';
      }
      if (string.length > maxLength) {
        return string.substring(0, string.lastIndexOf(separator, maxLength));
      }
      return string;
    }
  },
  computed: {
    hasCustomer() {
      return typeof this.damage.customer_id !== "undefined"
          && this.damage.customer_id !== null
          && typeof this.damage.customer !== "undefined"
          && this.damage.customer !== null;
    },
    hasCustomerData() {
      return this.hasCustomer && typeof this.damage.customer.data !== 'undefined' && this.damage.customer.data !== null;
    },
    getEmail() {
      if (this.hasCustomerData) {
        return this.damage.customer.data.email_address;
      }
    },
    getPhone() {
      if (this.hasCustomerData) {
        return this.damage.customer.data.phone;
      }
    },
    getMobile() {
      if (this.hasCustomerData) {
        return this.damage.customer.data.mobile;
      }
    },
    getProperty() {
      const property = this.damage.customer.data.addresses.data[0];

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street_name,
          number: property.house_number,
          number_addition: property.house_number_addition ? property.house_number_addition : '',
          postal_code: property.postcode.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : '',
        };
      }

      return null;
    },
    getDamageLink() {
      if (this.hasCustomer) {
        return "/customer/" + this.damage.customer_id + "/damage/" + this.damage.id;
      }
      return '';
    },
    hasAgencyData() {
      return typeof this.damage.agency !== "undefined"
          && this.damage.agency !== null
          && typeof this.damage.agency.data !== "undefined"
          && this.damage.agency.data !== null;
    },
    getAgencyName() {
      return this.hasAgencyData ? this.damage.agency.data.name : '';
    }
  }
}
</script>

<style scoped>

</style>